import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { executionDateTicketMilestone } from '../../../actions/service_request';
import RenderMilestones from '../components/RenderMileStones';
import { useForm } from 'react-hook-form';
import Form from '../../../common/Form';
import TextArea from '../../../common/Form/TextArea';
import MultiSelectDatePicker from '../../../common/Form/MultiDatePicker';
import RenderRemarksInput from '../../../components/Inputs/RenderRemarksInput';
import { actualValueForDropdown, ScogoID } from '../../../utils/common';
import moment from 'moment';
import MultiSelectDateTimePicker from '../../../common/Form/MultiSelectDateTimePicker';

export const formName = 'siteCompleteForm';

const ExecutionDate = ({ ticketId, milestones, agents }) => {
    const dispatch = useDispatch();
    const [selectedMilestones, setSelectedMilestones] = useState();
    const formButtonLoading = useSelector(state => state.loading.formButtonLoading);
    const { newLoggedUserData } = useSelector(state => state.auth);
    const isScogoOrg = newLoggedUserData?.org?.id === ScogoID;

    const handleCancel = () => {
        dispatch(closeModalAction());
    };

    const methods = useForm({ defaultValues: {}, mode: 'all' });

    useEffect(() => {
        if (milestones && selectedMilestones) {
            const dates = milestones.find(milestone => milestone.id === selectedMilestones).execution_dates.map(({ date }) => new Date(date));
            if (dates && dates.length > 0) methods.setValue('dates', dates);
        }
    }, [milestones, selectedMilestones, methods]);

    const handleSubmit = (formValues) => {
        const payload = {
            remark: actualValueForDropdown(formValues.remark) === 'create_this_issue' ? formValues?.remark?.label : actualValueForDropdown(formValues.remark),
            dates: formValues.dates ? formValues.dates.map(date => moment(date)) : []
        };
        dispatch(executionDateTicketMilestone({ ticketId, milestoneId: selectedMilestones, formName, payload }));
    };

    return (
        <div className="px-6 py-4 relative overflow-hidden">
            <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} />
            <div className='w-full'>
                <Form
                    className='w-full'
                    methods={methods}
                    onSubmit={handleSubmit}
                    showSubmit
                    isLoading={formButtonLoading[formName]}
                    onCancel={handleCancel}
                    submitContainerClassName='flex gap-2 justify-end py-4 px-4 relative'
                >
                    <div className='grid grid-cols-2 gap-4'>
                        <MultiSelectDateTimePicker
                            required
                            name='dates'
                            label='Execution Dates'
                            minDate={isScogoOrg ? undefined : new Date()}
                        />
                        <RenderRemarksInput required name='remark' label='Remarks' category={'EXECUTION_DATE_CHANGE'} />
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default ExecutionDate;
